import script from "./WrapStEthLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./WrapStEthLink.vue?vue&type=script&setup=true&lang=ts"

export default script